import { withTranslation } from 'next-i18next';
import PropTypes from 'prop-types';
import { useRef } from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import Icon from '@/components/common/iconedLinks/Icon';
import { NS } from '@/constants';
import styles from './IconedLink.module.scss';

export const IconedLink = ({ t, id, onClicked, text, tooltip, icon, width, height, alt, rbf }) => {
	const linkRef = useRef();
	return (
		<>
			<a
				id={id}
				data-rbf={rbf || id}
				ref={linkRef}
				className={styles.container}
				onClick={onClicked}
				data-test-id="iconed-link"
			>
				{text && <span className="tu-text">{t(text)}</span>}
				{icon && <Icon src={icon} alt={alt ?? 'icon'} className="icon" width={width || 12} height={height || 12} />}
			</a>
			{tooltip && <UncontrolledTooltip target={linkRef}>{t(tooltip)}</UncontrolledTooltip>}
		</>
	);
};

IconedLink.propTypes = {
	t: PropTypes.func.isRequired,
	id: PropTypes.string,
	onClicked: PropTypes.func.isRequired,
	text: PropTypes.string,
	tooltip: PropTypes.string,
	icon: PropTypes.string,
	width: PropTypes.number,
	height: PropTypes.number,
	alt: PropTypes.string,
	rbf: PropTypes.string,
};

export default withTranslation(NS.COMMON)(IconedLink);
